import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ '@/views/home'),
      meta: {
        show: true,
      },
    },
    {
      path: '/adapterDetails',
      name: 'adapterDetails',
      component: () => import(/* webpackChunkName: "adapterDetails" */ '@/views/content/detail/AdapterDetails.vue'),
      meta: {
        show: false,
      },
    },
    {
      path: '/403',
      name: '403',
      component: () => import(/* webpackChunkName: "exception" */ '@/views/exception/403'),
      meta: {
        show: true,
      },
    },
    {
      path: '/404',
      name: '404',
      component: () => import(/* webpackChunkName: "exception" */ '@/views/exception/404'),
      meta: {
        show: true,
      },
    },
    {
      path: '/500',
      name: '500',
      component: () => import(/* webpackChunkName: "exception" */ '@/views/exception/500'),
      meta: {
        show: true,
      },
    },
    {
      path: '/search',
      name: 'search',
      redirect: '/search/:question',
      component: () => import(/* webpackChunkName: "search" */ '@/views/search'),
      meta: {
        show: true,
      },
      children: [
        {
          path: 'detail/:detailId',
          component: () => import(/* webpackChunkName: "contentDetail" */ '@/views/content/detail'),
          meta: {
            show: true,
          },
        },
        {
          path: ':question',
          component: () => import(/* webpackChunkName: "contentList" */ '@/views/content/list'),
          meta: {
            show: true,
          },
        },
      ],
    },
    {
      path: '/redirect/:content',
      name: 'redirect',
      component: () => import(/* webpackChunkName: "redirect" */ '@/views/redirect'),
      meta: {
        show: true,
      },
    },
    {
      path: '/redirectId/:colId',
      name: 'redirectId',
      component: () => import(/* webpackChunkName: "redirectId" */ '@/views/redirectId'),
      meta: {
        show: true,
      },
    },
    {
      path: '/redirectId/:colId/:parentQlwId',
      name: 'redirectId',
      component: () => import(/* webpackChunkName: "redirectId" */ '@/views/redirectId'),
      meta: {
        show: true,
      },
    },
    {
      path: '/:navId',
      name: 'content',
      redirect: '/:navId/list/0',
      component: () => import(/* webpackChunkName: "content" */ '@/views/content'),
      meta: {
        show: true,
      },
      children: [
        {
          path: 'list/:listId',
          component: () => import(/* webpackChunkName: "contentList" */ '@/views/content/list'),
          meta: {
            show: true,
          },
        },
        {
          path: 'detail/:detailId',
          component: () => import(/* webpackChunkName: "contentDetail" */ '@/views/content/detail'),
          meta: {
            show: true,
          },
        },
      ],
    },

    {
      path: '*',
      name: '404',
      component: () => import(/* webpackChunkName: "exception" */ '@/views/exception/404'),
      meta: {
        show: true,
      },
    },
  ],
});
